import cx from 'classnames';
import {
  ResizeDirection,
  ResizeEvent,
  ResizeHandle as ResizeHandlePrimitive,
} from 'lib-knowledge-document-structure/plate/resizable';

import s from './resizeHandle.module.scss';

export type ResizeHandleProps = {
  side: ResizeDirection;
  closeHandle?: boolean;
  onResize?: (event: ResizeEvent) => void;
} & React.HTMLAttributes<HTMLDivElement>;

export const ResizeHandle = ({
  side,
  className,
  closeHandle,
  onResize,
  ...props
}: ResizeHandleProps): JSX.Element => {
  return (
    <ResizeHandlePrimitive
      className={cx(
        {
          [s['resizeHandleLeft']]: side === 'left',
          [s['resizeHandleRight']]: side === 'right',
          [s['resizeHandleTop']]: side === 'top',
          [s['resizeHandleBottom']]: side === 'bottom',
          [s['resizeHandleHorizontal']]: side === 'left' || side === 'right',
          [s['resizeHandleVertical']]: side === 'top' || side === 'bottom',
          [s['close']]: closeHandle,
        },
        s['resizeHandle'],
        className,
      )}
      options={{
        direction: side,
        onResize,
      }}
      {...props}
    />
  );
};
